import axios from 'axios';
import qs from 'qs';

const PWCIttURL = 'https://hypermeta.itt.link';


const PWCIttApi = axios.create({
  baseURL: PWCIttURL
});

export const getITTContentsList = async (option) => {
  const newOption = option;
  Object.keys(option).forEach(
    (key) =>
      (option[key] === null ||
        option[key] === undefined ||
        (Array.isArray(option[key]) && option[key].length < 1)) &&
      delete option[key]
  );
  
  const query = qs.stringify(newOption, {
    encode: true,
    addQueryPrefix: true
  });
  try {
    const res = await PWCIttApi.get(`/api/contents/search${query}`);
    return res;
  } catch (error) {
    throw new Error(error);
  }
};
